import React, { useEffect, useMemo, useState } from "react";
import DashboardLayout from "./DashboardLayout";
import { useNavigate } from "react-router-dom";
import { getPaymentHistory } from "../services/PaymentService";
import { getCustomerInfo } from "../services/customerService";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

import {
    FaCheckCircle,
    FaClock,
    FaExclamationCircle,
    FaMoneyBillWave,
    FaSearch,
} from "react-icons/fa";

const getStatusStyle = (status) => {
    switch (status) {
        case "پرداخت موفق":
            return "bg-green-100 text-green-700";

        case "در حال پردازش":
            return "bg-yellow-100 text-yellow-700";

        case "ناموفق":
            return "bg-red-100 text-red-700";

        default:
            return "bg-gray-100 text-gray-700";
    }
};

const PaymentHistory = () => {
    const navigate = useNavigate();
    // const { customer } = useCustomer();

    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedPayment, setSelectedPayment] = useState(null);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [filteredPayments, setFilteredPayments] = useState([]);
    const [invoiceFilter, setInvoiceFilter] = useState("");

    useEffect(() => {
        loadPayments();
    }, []);

    const loadPayments = async () => {
        try {
            setLoading(true);

            const customerResponse =
                await getCustomerInfo();

            console.log(customerResponse.data);

            const paymentResponse =
                await getPaymentHistory(
                    customerResponse.data.customerId
                );

            setPayments(paymentResponse.data);
            setFilteredPayments(paymentResponse.data);

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleFilter = () => {
        let result = [...payments];

        // فیلتر شماره فاکتور
        if (invoiceFilter) {
            result = result.filter(
                x =>
                    x.invoiceId
                        ?.toString()
                        .includes(invoiceFilter)
            );
        }

        // فیلتر تاریخ از
        if (fromDate) {
            const from = fromDate.toDate();

            result = result.filter(
                x =>
                    x.displayDate &&
                    new Date(x.displayDate) >= from
            );
        }

        // فیلتر تاریخ تا
        if (toDate) {
            const to = toDate.toDate();

            result = result.filter(
                x =>
                    x.displayDate &&
                    new Date(x.displayDate) <= to
            );
        }

        setFilteredPayments(result);
    };

    const summaryCards = useMemo(() => {
        const successCount = payments.filter(
            (x) => x.statusTitle === "پرداخت موفق"
        ).length;

        const pendingCount = payments.filter(
            (x) => x.statusTitle === "در حال پردازش"
        ).length;

        const failedCount = payments.filter(
            (x) => x.statusTitle === "ناموفق"
        ).length;

        const totalAmount = payments.reduce(
            (sum, item) => sum + item.amount,
            0
        );

        return [
            {
                title: "پرداخت موفق",
                value: successCount,
                icon: FaCheckCircle,
                color: "#16a34a",
                bg: "#dcfce7",
            },
            {
                title: "مجموع پرداخت‌ها",
                value: totalAmount.toLocaleString(),
                icon: FaMoneyBillWave,
                color: "#2563eb",
                bg: "#dbeafe",
            },
            {
                title: "در حال پردازش",
                value: pendingCount,
                icon: FaClock,
                color: "#d97706",
                bg: "#fef3c7",
            },
            {
                title: "ناموفق",
                value: failedCount,
                icon: FaExclamationCircle,
                color: "#dc2626",
                bg: "#fee2e2",
            },
        ];
    }, [payments]);

    return (
        <DashboardLayout>
            {/* Header */}
            <div className="flex items-center justify-between px-6 mb-6">
                <h1 className="text-base sm:text-lg md:text-xl font-bold text-blue-700">
                    سوابق پرداخت آنلاین
                </h1>

                <button
                    onClick={() => navigate("/financial-info")}
                    className="px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white text-sm rounded"
                >
                    بازگشت
                </button>
            </div>

            {/* Summary */}
            <div className="w-full max-w-screen-2xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 px-4 mb-6">
                {summaryCards.map((card, index) => {
                    const Icon = card.icon;

                    return (
                        <div
                            key={index}
                            className="rounded-xl shadow-md p-1 border border-gray-100"
                            style={{ backgroundColor: card.bg }}
                        >
                            <div className="text-xs text-gray-500 font-semibold">
                                {card.title}
                            </div>

                            <div className="flex items-center justify-between mt-3">
                                <div
                                    className="text-md font-extrabold"
                                    style={{ color: card.color }}
                                >
                                    {card.value}
                                </div>

                                <div
                                    className="hidden md:flex p-2 rounded-full"
                                    style={{ backgroundColor: `${card.color}22` }}
                                >
                                    <Icon
                                        className="text-lg"
                                        style={{ color: card.color }}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

            {/* <div className="w-full max-w-screen-2xl mx-auto px-4 mb-6">
                <div className="bg-white rounded-xl shadow-md p-4 border border-gray-100">

                    <div className="flex flex-wrap items-center gap-y-2 gap-x-3 sm:gap-x-4">

                        <div className="flex items-center gap-2 whitespace-nowrap">
                            <span className="text-sm">فاکتور:</span>

                            <input
                                type="text"
                                value={invoiceFilter}
                                onChange={(e) =>
                                    setInvoiceFilter(e.target.value)
                                }
                                placeholder="شماره فاکتور"
                                className="border rounded px-2 py-1 w-28 sm:w-32 text-center text-sm"
                            />
                        </div>

                        <div className="flex items-center gap-1 whitespace-nowrap">
                            <span className="text-sm">از تاریخ:</span>

                            <DatePicker
                                calendar={persian}
                                locale={persian_fa}
                                value={fromDate}
                                onChange={setFromDate}
                                format="YYYY/MM/DD"
                                inputClass="border rounded px-1 py-1 w-24 sm:w-28 md:w-32 text-center text-xs sm:text-sm"
                            />
                        </div>

                        <div className="flex items-center gap-1 whitespace-nowrap">
                            <span className="text-sm">تا تاریخ:</span>

                            <DatePicker
                                calendar={persian}
                                locale={persian_fa}
                                value={toDate}
                                onChange={setToDate}
                                format="YYYY/MM/DD"
                                inputClass="border rounded px-1 py-1 w-24 sm:w-28 md:w-32 text-center text-xs sm:text-sm"
                            />
                        </div>

                        <button
                            onClick={handleFilter}
                            className="bg-blue-600 text-white text-sm px-3 py-2 rounded hover:bg-blue-500 flex items-center gap-2"
                        >
                            <FaSearch />
                            اعمال فیلتر
                        </button>

                        <button
                            onClick={() => {
                                setInvoiceFilter("");
                                setFromDate(null);
                                setToDate(null);
                                setFilteredPayments(payments);
                            }}
                            className="bg-gray-200 text-gray-700 text-sm px-3 py-2 rounded hover:bg-gray-300"
                        >
                            حذف فیلتر
                        </button>

                    </div>

                </div>
            </div> */}
            {/* Filter Section */}
            {/* Container مشترک با جدول */}
            <div className="w-full max-w-screen-xl mx-auto px-4 mb-4">

                <div className="bg-white rounded-xl shadow-md border border-gray-100 p-4 text-xs">

                    <div className="flex flex-col gap-3 lg:flex-row lg:flex-wrap lg:items-center lg:justify-center">

                        {/* شماره فاکتور */}
                        <div className="flex items-center gap-2">
                            <span className="font-bold whitespace-nowrap">
                                فاکتور:
                            </span>

                            <input
                                type="text"
                                value={invoiceFilter}
                                onChange={(e) =>
                                    setInvoiceFilter(e.target.value)
                                }
                                placeholder="شماره فاکتور"
                                className="flex-1 lg:flex-none border rounded px-3 py-2 text-xs w-full lg:w-40"
                            />
                        </div>

                        {/* تاریخ ها */}
                        <div className="grid grid-cols-2 gap-2 sm:flex sm:items-center sm:gap-3">

                            <div className="flex items-center gap-1">
                                <span className="whitespace-nowrap">
                                    از تاریخ:
                                </span>

                                <DatePicker
                                    calendar={persian}
                                    locale={persian_fa}
                                    value={fromDate}
                                    onChange={setFromDate}
                                    format="YYYY/MM/DD"
                                    inputClass="border rounded px-2 py-2 w-full lg:w-32 text-center text-xs"
                                />
                            </div>

                            <div className="flex items-center gap-1">
                                <span className="whitespace-nowrap">
                                    تا تاریخ:
                                </span>

                                <DatePicker
                                    calendar={persian}
                                    locale={persian_fa}
                                    value={toDate}
                                    onChange={setToDate}
                                    format="YYYY/MM/DD"
                                    inputClass="border rounded px-2 py-2 w-full lg:w-32 text-center text-xs"
                                />
                            </div>

                        </div>

                        {/* دکمه ها */}
                        <div className="grid grid-cols-2 gap-2 lg:flex lg:gap-2">

                            <button
                                onClick={handleFilter}
                                className="bg-blue-600 hover:bg-blue-700 text-white rounded px-4 py-2 flex justify-center items-center  gap-2"
                            >
                                <FaSearch size={12} />
                                اعمال فیلتر
                            </button>

                            <button
                                onClick={() => {
                                    setInvoiceFilter("");
                                    setFromDate(null);
                                    setToDate(null);
                                    setFilteredPayments(payments);
                                }}
                                className="bg-gray-200 hover:bg-gray-300  rounded px-4 py-2"
                            >
                                حذف فیلتر
                            </button>

                        </div>

                    </div>

                </div>

            </div>



            {/* Loading */}
            {loading && (
                <div className="text-center py-10">
                    در حال دریافت اطلاعات...
                </div>
            )}

            {/* Table */}
            {!loading && (
                <>
                    {/* Mobile View */}
                    <div className="md:hidden px-4 space-y-3">

                        {filteredPayments.length === 0 && (
                            <div className="bg-white rounded-xl shadow p-6 text-center text-gray-500 text-sm">
                                سابقه پرداختی یافت نشد
                            </div>
                        )}

                        {filteredPayments.map((payment, index) => (

                            <div
                                key={index}
                                className="bg-white rounded-xl shadow border border-gray-100 p-3"
                            >

                                <div className="flex justify-between mb-2">
                                    <span className="text-gray-500 text-xs">
                                        ردیف
                                    </span>

                                    <span className="font-bold text-xs">
                                        {index + 1}
                                    </span>
                                </div>

                                <div className="flex justify-between mb-2">
                                    <span className="text-gray-500 text-xs">
                                        شماره فاکتور
                                    </span>

                                    <span className="font-bold text-blue-700 text-sm">
                                        {payment.invoiceId}
                                    </span>
                                </div>

                                <div className="flex justify-between mb-2">
                                    <span className="text-gray-500 text-xs">
                                        مبلغ
                                    </span>

                                    <span className="text-sm">
                                        {payment.amount?.toLocaleString()}
                                    </span>
                                </div>

                                <div className="flex justify-between mb-2">
                                    <span className="text-gray-500 text-xs">
                                        تاریخ پرداخت
                                    </span>

                                    <span className="text-sm">
                                        {payment.displayDate
                                            ? new Date(
                                                payment.displayDate
                                            ).toLocaleDateString("fa-IR")
                                            : "-"}
                                    </span>
                                </div>

                                <div className="flex justify-between mb-3">
                                    <span className="text-gray-500 text-xs">
                                        وضعیت
                                    </span>

                                    <span
                                        className={`px-2 py-1 rounded-full text-xs font-bold ${getStatusStyle(
                                            payment.statusTitle
                                        )}`}
                                    >
                                        {payment.statusTitle}
                                    </span>
                                </div>

                                <button
                                    onClick={() =>
                                        setSelectedPayment(payment)
                                    }
                                    className="w-full bg-blue-600 hover:bg-blue-700 text-white rounded-lg py-2 text-xs font-medium"
                                >
                                    مشاهده جزئیات
                                </button>

                            </div>

                        ))}

                    </div>

                    {/* Desktop View */}
                    <div className="hidden md:block">
                        <div className="w-full max-w-screen-xl mx-auto px-4">

                            <div className="bg-white rounded-xl shadow-md overflow-x-auto border border-gray-100">

                                <table className="w-full text-xs text-center">

                                    <thead className="bg-blue-50 text-blue-900">

                                        <tr>
                                            <th className="py-4 px-2">ردیف</th>
                                            <th>شماره فاکتور</th>
                                            <th>مبلغ</th>
                                            <th>تاریخ پرداخت</th>
                                            <th>وضعیت</th>
                                            <th>جزئیات</th>
                                        </tr>

                                    </thead>

                                    <tbody>

                                        {filteredPayments.map((payment, index) => (

                                            <tr
                                                key={index}
                                                className="border-t hover:bg-gray-50"
                                            >

                                                <td className="py-4">
                                                    {index + 1}
                                                </td>

                                                <td className="font-bold text-blue-700">
                                                    {payment.invoiceId}
                                                </td>

                                                <td>
                                                    {payment.amount?.toLocaleString()}
                                                </td>

                                                <td>
                                                    {payment.displayDate
                                                        ? new Date(
                                                            payment.displayDate
                                                        ).toLocaleDateString("fa-IR")
                                                        : "-"}
                                                </td>

                                                <td>

                                                    <span
                                                        className={`px-3 py-1 rounded-full text-xs font-bold ${getStatusStyle(
                                                            payment.statusTitle
                                                        )}`}
                                                    >
                                                        {payment.statusTitle}
                                                    </span>

                                                </td>

                                                <td>

                                                    <button
                                                        onClick={() =>
                                                            setSelectedPayment(payment)
                                                        }
                                                        className="text-blue-600 hover:text-blue-800 font-bold"
                                                    >
                                                        مشاهده
                                                    </button>

                                                </td>

                                            </tr>

                                        ))}

                                    </tbody>

                                </table>

                                {filteredPayments.length === 0 && (

                                    <div className="text-center py-10 text-gray-500">
                                        سابقه پرداختی یافت نشد
                                    </div>

                                )}

                            </div>

                        </div>
                    </div>
                </>
            )}
            {/* Modal */}
            {selectedPayment && (
                <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-2xl shadow-xl w-[90%] md:w-[500px] p-6">
                        <div className="flex items-center justify-between mb-5">
                            <h2 className="text-md font-bold text-blue-700">
                                جزئیات پرداخت
                            </h2>

                            <button
                                onClick={() => setSelectedPayment(null)}
                                className="text-gray-500 hover:text-red-500 text-xl"
                            >
                                ×
                            </button>
                        </div>

                        <div className="space-y-4 text-xs">
                            <div className="flex justify-between">
                                <span>شماره فاکتور</span>
                                <span>{selectedPayment.invoiceId}</span>
                            </div>

                            <div className="flex justify-between">
                                <span>مبلغ</span>
                                <span>
                                    {selectedPayment.amount?.toLocaleString()}
                                </span>
                            </div>

                            <div className="flex justify-between">
                                <span>تاریخ پرداخت</span>
                                <span>
                                    {selectedPayment.displayDate
                                        ? new Date(
                                            selectedPayment.displayDate
                                        ).toLocaleDateString("fa-IR")
                                        : "-"}
                                </span>
                            </div>

                            <div className="flex justify-between">
                                {/* <span>کد پیگیری بانک</span>
                                <span>
                                    {selectedPayment.transactionId ||
                                        "-"}
                                </span> */}
                                <span>شناسه تراکنش</span>
                                <span>
                                    {selectedPayment.transactionId}
                                </span>
                            </div>

                            <div className="flex justify-between">
                                <span>وضعیت</span>

                                <span
                                    className={`px-3 py-1 rounded-full text-xs font-bold ${getStatusStyle(
                                        selectedPayment.statusTitle
                                    )}`}
                                >
                                    {selectedPayment.statusTitle}
                                </span>
                            </div>

                            {/* <div className="flex justify-between">
                               
                            </div> */}
                        </div>
                    </div>
                </div>
            )}
        </DashboardLayout>
    );
};

export default PaymentHistory;